export default "__VITE_ASSET__CZ6TE1a0__"